import { UserMenus } from "./types";

const UserInfo = ({ userData }: { userData: UserMenus }) => {
  const doesUserNotHaveFreeTickets = userData?.FreeTicketNotification?.AllAvailableFreeTickets === 0;
  const onFreeTicketsClick = () => {
    if (doesUserNotHaveFreeTickets) {
      return;
    }
    location.href = "/account/my-wallet";
  };
  return (
    <div className="relative flex flex-col gap-3 bg-white shadow-[0px_1.5px_4px_0px_rgba(0,0,0,0.20)] rounded-lg lg:hidden p-4">
      <div className="flex flex-col gap-1">
        <div className="text-base font-medium leading-5.5 text-dark-1 font-jost">Hello {userData?.FirstName},</div>
        <div className="text-gray-1 text-xs font-normal font-roboto leading-4">You have:</div>
      </div>
      <div className="w-full h-px bg-black/8" />
      {userData?.TierImageUrl && (
        <img
          className="absolute top-[20px] right-[20px]"
          src={userData?.TierImageUrl}
          alt="user-loyalty-tier-image"
          width={25}
          height={25}
        />
      )}
      <div className={"flex items-center justify-between text-sm"}>
        <div className={"text-secondary font-normal leading-5 inline-flex items-center gap-1"}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M14.375 2.42241C15.7052 3.19038 16.8098 4.29497 17.5777 5.62515C18.3457 6.95533 18.75 8.46423 18.75 10.0002C18.75 11.5361 18.3457 13.045 17.5777 14.3752C16.8097 15.7054 15.7051 16.8099 14.3749 17.5779C13.0447 18.3459 11.5358 18.7502 9.99986 18.7501C8.46391 18.7501 6.95502 18.3458 5.62486 17.5778C4.29469 16.8098 3.19013 15.7052 2.42218 14.375C1.65423 13.0448 1.24996 11.5359 1.25 9.99991L1.25438 9.71641C1.30338 8.20527 1.7431 6.73262 2.53068 5.44203C3.31826 4.15143 4.42682 3.08693 5.74828 2.3523C7.06974 1.61768 8.559 1.238 10.0709 1.25029C11.5828 1.26257 13.0657 1.6664 14.375 2.42241ZM10.875 4.74991C10.1788 4.74991 9.51113 5.02647 9.01884 5.51875C8.52656 6.01103 8.25 6.67871 8.25 7.37491V9.12491H7.375C7.16068 9.12493 6.95383 9.20362 6.79367 9.34603C6.63352 9.48845 6.5312 9.68469 6.50612 9.89753L6.5 9.99991C6.5 10.232 6.59219 10.4545 6.75628 10.6186C6.92038 10.7827 7.14294 10.8749 7.375 10.8749H8.25V11.7499C8.25016 11.9471 8.1837 12.1386 8.06141 12.2933C7.93912 12.448 7.76816 12.5568 7.57625 12.6022L7.47737 12.6197L7.375 12.6249C6.24888 12.6249 6.2095 14.2559 7.25862 14.3688L7.375 14.3749H12.625C12.8571 14.3749 13.0796 14.2827 13.2437 14.1186C13.4078 13.9545 13.5 13.732 13.5 13.4999L13.4939 13.3975C13.4688 13.1847 13.3665 12.9884 13.2063 12.846C13.0462 12.7036 12.8393 12.6249 12.625 12.6249H9.85038L9.89237 12.4954C9.9639 12.2534 10.0001 12.0023 10 11.7499V10.8749H10.875C11.0893 10.8749 11.2962 10.7962 11.4563 10.6538C11.6165 10.5114 11.7188 10.3151 11.7439 10.1023L11.75 9.99991C11.75 9.76784 11.6578 9.54528 11.4937 9.38119C11.3296 9.21709 11.1071 9.12491 10.875 9.12491H10V7.37491C10 7.16059 10.0787 6.95374 10.2211 6.79358C10.3635 6.63343 10.5598 6.53111 10.7726 6.50603L10.875 6.49991C11.0893 6.49993 11.2962 6.57862 11.4563 6.72103C11.6165 6.86345 11.7188 7.05969 11.7439 7.27253L11.75 7.37491C11.75 7.60697 11.8422 7.82953 12.0063 7.99362C12.1704 8.15772 12.3929 8.24991 12.625 8.24991C12.8571 8.24991 13.0796 8.15772 13.2437 7.99362C13.4078 7.82953 13.5 7.60697 13.5 7.37491C13.5 6.67871 13.2234 6.01103 12.7312 5.51875C12.2389 5.02647 11.5712 4.74991 10.875 4.74991Z"
              fill="#FF8200"
            />
          </svg>
          <span>Game Credit:</span>{" "}
          <span className={"text-primary font-semibold leading-5"}>
            {userData?.UserDetails.FormattedTotalGameCredits}
          </span>
        </div>
        {userData?.FreeTicketNotification?.AllAvailableFreeTickets > 0 && (
          <div
            onClick={onFreeTicketsClick}
            className={"text-secondary font-normal leading-5 inline-flex items-center gap-1"}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M19.749 7.888V4C19.749 3.17125 19.0778 2.5 18.249 2.5H1.74902C0.920273 2.5 0.249023 3.17125 0.249023 4V7.888C1.12127 8.19775 1.74902 9.022 1.74902 10C1.74902 10.978 1.12127 11.8022 0.249023 12.112V16C0.249023 16.8287 0.920273 17.5 1.74902 17.5H18.249C19.0778 17.5 19.749 16.8287 19.749 16V12.112C18.8768 11.8022 18.249 10.978 18.249 10C18.249 9.022 18.8768 8.19775 19.749 7.888ZM14.163 9.22075L11.9865 10.8407L12.795 13.4305C12.9038 13.7778 12.5093 14.0642 12.2123 13.8535L9.99902 12.2845L7.78577 13.8535C7.48877 14.0642 7.09502 13.7778 7.20302 13.4305L8.01152 10.8407L5.83502 9.22075C5.54327 9.004 5.69402 8.5405 6.05777 8.536L8.77052 8.5045L9.63902 5.93425C9.75527 5.59 10.2428 5.59 10.359 5.93425L11.2275 8.5045L13.9403 8.536C14.304 8.53975 14.4548 9.00325 14.163 9.22075Z"
                fill={doesUserNotHaveFreeTickets ? "#DADADA" : "#FF8200"}
              />
            </svg>
            Free Tickets:{" "}
            <span className={"text-primary font-semibold leading-5"}>
              {userData?.FreeTicketNotification?.AllAvailableFreeTickets}
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M6 4L10 8L6 12"
                stroke="#898994"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserInfo;
